import React from 'react';
import bg from "../../Assets/img/bg.jpg";
import Map from "../Includes/Map";
import {Helmet} from "react-helmet";

const Contact = () => {
    return (
        <>
            <Helmet>
                <title>Contact | Mega Dumpster Bin Rental - Best Company That Lets You Clean & Remove Trash & Rubbish</title>
            </Helmet>
            <section>
                <div className="container-fluid g-0">
                    <div className="page-banner">
                        <img src={bg} className="img-fluid" alt="About Us"/>
                        <div className="overly"/>
                        <div className="content">
                            <h1 className="display-1 text-white text-uppercase">Contact</h1>
                        </div>
                    </div>
                </div>
                <div className="container section-gap">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="card my-card h-100">
                                <div className="card-header">
                                    <h4 className="text-uppercase">Get in touch</h4>
                                </div>
                                <div className="card-body px-5 py-3">
                                    <form>
                                        <label>Name
                                            <input type="name" className="form-control" placeholder="Enter Your Full Name"/>
                                        </label>
                                        <label>Subject
                                            <input type="name" className="form-control" placeholder="Enter Your Full Name"/>
                                        </label>
                                        <label>Message
                                            <textarea className="form-control" placeholder="Enter Your Message"/>
                                        </label>
                                        <div className="d-grid mt-3">
                                            <button className="btn btn-success">SEND MESSAGE</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="card my-card h-100">
                                <div className="card-header"><h4 className="text-uppercase">Contact us</h4></div>
                                <div className="card-body px-5 py-3">
                                    <div className="about-contact mt-5">
                                        <div className="row my-3">
                                            <div className="col-2"><i className="fa fa-map-marker"/></div>
                                            <div className="col-10"><p>8444 Reseda Blvd, Northridge, CA</p></div>
                                        </div>
                                        <div className="row my-3">
                                            <div className="col-2"><i className="fa fa-phone"/></div>
                                            <div className="col-10"><a href="tel:8187737599">(818) 773-7599</a></div>
                                        </div>
                                        <div className="row my-3">
                                            <div className="col-2"><i className="fa fa-paper-plane"/></div>
                                            <div className="col-10"><a
                                                href="mailto:sublimeproinc@gmail.com">sublimeproinc@gmail.com</a></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Map/>
        </>

    );
};

export default Contact;
